<ng-content></ng-content>
@if (drawMode) {
  <ion-fab id="bottom-anchor" slot="fixed" horizontal="center" vertical="bottom">
    <div class="tw:flex tw:text-center">
      <ion-fab-button color="light" (click)="clear()" class="tw:mx-2">
        <ion-icon src="/assets/svg/eraser.svg"></ion-icon>
      </ion-fab-button>
      <ion-fab-button size="small" color="danger" (click)="toggleDrawMode()" class="tw:mx-2">
        <ion-icon name="close-circle-outline"></ion-icon>
      </ion-fab-button>
    </div>
  </ion-fab>
} @else {
  <div class="tw:absolute tw:bottom-2 tw:left-2/4 tw:-ml-28 tw:flex tw:w-56 tw:justify-center">
    <ion-button shape="round" (click)="toggleDrawMode()">
      <ion-icon slot="start" src="assets/svg/route.svg"></ion-icon>
      Draw Walk Order
    </ion-button>
  </div>
}
